class EfdUploadModal {
    constructor(gql, scope, $filter, Efds, Empresas) {
        this.apply = (fn) => scope.$apply(fn)
        this.gql = gql
        this.$filter = $filter
        this.Efds = Efds
        this.Empresas = Empresas
    }

    $onInit() {
        this.promise = this.Empresas
            .getEmpresa(this.resolve.empresaId)
            .then(empresa => this.empresa = empresa)
            .finally(() => this.apply())
    }

    submit() {
        if (this.form && this.form.$valid) {
            this.upload()
        }
    }

    upload() {
        this.error = null

        this.uploadPromise = this.efd.tipo === 'ICMS'
            ? this.Efds.importEfdIcms(this.resolve.empresaId, this.file)
            : this.Efds.importEfdPisCofins(this.resolve.empresaId, this.file)

        this.uploadPromise
            .then(efd => this.showSuccessMessageAndClose(efd))
            .catch(([err]) => {
                this.error = this.getErrorMessage(err.key)
                return Promise.reject(err)
            })
            .finally(() => this.apply())
    }

    showSuccessMessageAndClose(efd) {
        Alert.success(`Arquivos referentes ao mês <b>${this.formatDate(efd.dataReferencia, 'MMM/yyyy')}</b> foram enviados com sucesso.`, 'Sucesso', 10000);
        this.close()
    }

    getErrorMessage(message) {
        switch (message) {
            case "cnpj_divergente":
                return "O CNPJ presente no arquivo não corresponde ao da filial selecionada.";
            case "raiz_divergente":
                return "O CNPJ presente no arquivo não pertence à raiz da filial selecionada.";
            case "invalid_header":
                return "O tipo selecionado não corresponde ao do arquivo enviado.";
            case "data_referencia":
                return 'Um outro arquivo já foi enviado e está sendo processado.'
            default:
                return "Erro desconhecido. Por favor, entre em contato com o suporte técnico.";
        }
    }

    verifyArquivo(arquivo, formInput) {
        formInput.$setValidity('cnpjMismatch', true)
        formInput.$setValidity('invalidFile', true)
        this.efd = null

        if (arquivo) {
            this.Efds
                .extractHeader(arquivo)
                .then(efd => {
                    this.efd = efd
                    formInput.$setValidity('cnpjMismatch', this.empresa.raizCnpj === efd.cnpj.substr(0, 8))
                })
                .catch(() => formInput.$setValidity('invalidFile', false))
                .finally(() => this.apply())
        }
    }

    formatDate(date, format = 'yyyy-MM-dd') {
        return this.$filter('date')(date, format)
    }
}

angular.module('eficienciaFiscalModule')
    .component('efdUploadModal', {
        controller: ['gql', '$scope', '$filter', 'Efds', 'Empresas', EfdUploadModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
            <promise-tracker promise="$ctrl.uploadPromise" active="isSendingLoading" error="sendingError">
                <modal title="Enviar arquivos EFD" close="$ctrl.close">
                    <modal-body>
                        <div class="clearfix">
                            <loading promise="$ctrl.promise">
                                <div class="form-group arquivo-input">
                                    <label>
                                        <span>
                                            Arquivo
                                            <span ng-if="$ctrl.efd.tipo === 'ICMS'">ICMS</span>
                                            <span ng-if="$ctrl.efd.tipo === 'PIS_COFINS'">PIS/COFINS</span>
                                        </span>
                                        <small ng-if="$ctrl.efd" class="text-muted">
                                            {{$ctrl.efd.dataReferencia | date: 'MMMM'}} de
                                            {{$ctrl.efd.dataReferencia | date: 'yyyy'}}
                                        </small>
                                    </label>
                                    <input 
                                        class="btn btn-default btn-block" 
                                        ngf-select 
                                        ngf-max-size="500MB" 
                                        uploader="$ctrl.uploader" 
                                        type="file" 
                                        name="file" 
                                        ng-model="$ctrl.file" 
                                        ng-change="$ctrl.verifyArquivo($ctrl.file, $ctrl.form.file)"
                                        ng-disabled="isSendingLoading || (sendingError && !$ctrl.error)"
                                        ng-required="true">
                                    <div ng-messages="$ctrl.form.file.$error" ng-messages-multiple ng-if="$ctrl.form.$submitted">
                                        <span class='help-block txt-color-red font-xs no-margin' ng-message="required">
                                            O envio de ao menos um dos dois arquivos é obrigatório.
                                        </span>
                                        <span class='help-block txt-color-red font-xs no-margin' ng-message="maxSize">
                                            O arquivo deve ter no máximo 500MB.
                                        </span>
                                        <span class='help-block txt-color-red font-xs no-margin' ng-message="invalidFile">
                                            O arquivo informado não é um EFD válido.
                                        </span>
                                        <span class='help-block txt-color-red font-xs no-margin' ng-message="cnpjMismatch">
                                            O arquivo informado não pertence a nenhuma filial da empresa <b class="text-italic">{{$ctrl.empresa.razaoSocial}}</b>.
                                        </span>
                                    </div>
                                </div>

                                <highlighted ng-if="sendingError">
                                    <main ng-if="$ctrl.efd.tipo === 'ICMS'">Não foi possível enviar o arquivo <b>EFD ICMS</b>.</main>
                                    <main ng-if="$ctrl.efd.tipo === 'PIS_COFINS'">Não foi possível enviar o arquivo <b>EFD PIS/COFINS</b>.</main>
                                
                                    <secondary>
                                        {{$ctrl.error}} <a href="javascript:void(0)" ng-click="$ctrl.submit()">Clique aqui</a> para tentar novamente.
                                    </secondary>
                                </highlighted>

                                <div class="file-uploading" ng-if="isSendingLoading">
                                    <h5><i class="fa fa-circle-o-notch fa-spin"></i> Importando arquivos...</h5>
                                </div>
                            </loading>
                        </div>
                    </modal-body>
                    <modal-footer>                    
                        <button class="btn btn-primary" type="submit" ng-disabled="isSendingLoading || sendingError">Enviar</button>
                        <button class="btn btn-default" type="button" ng-disabled="isSendingLoading" ng-click="$ctrl.close()">Fechar</button>
                    </modal-footer>
                </modal>
            </promise-tracker>
        </form>
        `
    })
